import { helpers } from 'vuelidate/lib/validators'

export const strongPassword = helpers.regex(
  'strongPassword',
  /(?=^\S{8,50}$)((?=.*\w)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[|#¿?¡!$&%^\"'~+*/\\<>=()\[\]\{\}\-\.]))^.*/
)

export const rfcValidation = helpers.regex(
  'rfcValidation',
  /^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Z]|[0-9]){2}([A]|[0-9]){1})?$/
)

export const rfcDuplicate = (data) =>
  helpers.withParams(
    { type: 'rfcDuplicate', value: data },
    function(value) {
      let sig = data.signers.find(s => s.rfc == value && s.id != data.id)
      return sig == undefined
    }
  )

export const rfcNotOwner = (data) =>
  helpers.withParams(
    { type: 'rfcNotOwner', value: data },
    function(value) {
      return data.owner.rfc != value || data.owner.rfc == (data.signer != undefined ? data.signer.rfc : '')
    }
  )

export const notSpecialChars = helpers.regex(
  'notSpecialChars',
  /^[^|#¿?¡!$%^*~+/\\<>=¨´\[\]\{\}`¬°]{1,254}$/
)

export const notSpecialCharsPunctuation = helpers.regex(
  'notSpecialCharsPunctuation',
  /^[^|#¿?¡!$%^*~+*/\\<>=¨´\[\]\{\}`¬\°\-@\.\:\;\,]{1,100}$/
)

export const notSpecialCharsDescription = helpers.regex(
  'notSpecialCharsDescription',
  /^[^|¿?¡!^~<>¨´\[\]\{\}`¬\°]{1,100}$/
)

export const emailValidation = helpers.regex(
  'emailValidation',
  /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/
)

export const emailDuplicate = (data) =>
  helpers.withParams(
    { type: 'emailDuplicate', value: data },
    function(value) {
      let sig = data.signers.find(s => s.email == value && s.id != data.id)
      return sig == undefined
    }
  )

export const emailNotOwner = (data) =>
  helpers.withParams(
    { type: 'emailNotOwner', value: data },
    function(value) {
      return data.owner.email != value || data.owner.email == (data.signer != undefined ? data.signer.email : '')
    }
  )

export const capitalize = (str, lower = false) =>
(lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase())